import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["formHiddenField", "checkoutModal", "confirmSelectionForm", "selectedQtyCounter", "infoModal", "customRequestModal", "mortarStatic", "mortarAnimation"];

  connect() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var scrollToElement = urlParams.get("scroll_to");
    if (!!scrollToElement) {
      document.getElementById(`${scrollToElement}`).scrollIntoView();
    }
  }

  openInfoModal() {
    this.infoModalTarget.classList.remove("hidden");
  }

  updateSelectedCheckboxes() {

    this.mortarAnimationTarget.classList.remove("hidden");
    this.mortarAnimationTarget.classList.add("animate__fadeIn", "animate__slower");
    var gifAnimationPath = "/assets/shop/mortaio10.gif?" + Math.random();
    // this.mortarAnimationTarget.src = "";
    this.mortarAnimationTarget.src = gifAnimationPath;
    
    var selectedCheckboxes = document.querySelectorAll("#selected_herb:checked");
    var ids = [...selectedCheckboxes].map((el) => el.value);

    console.log(ids);

    this.formHiddenFieldTarget.value = ids;
    
    

    if (selectedCheckboxes.length >= 1) {
      this.confirmSelectionFormTarget.classList.remove("hidden");
      this.selectedQtyCounterTarget.innerText = selectedCheckboxes.length;

 

      
      

      
      // this.mortarStaticTarget.classList.add("hidden");
      // this.mortarAnimationTarget.classList.remove("hidden");

      // setTimeout(() => {
      //   this.mortarAnimationTarget.classList.add("hidden");
      //   this.mortarStaticTarget.classList.remove("hidden");
      // }, 2000);

    } else {
      this.confirmSelectionFormTarget.classList.add("hidden");
    }

  }


  openCheckoutModal() {
    this.checkoutModalTarget.classList.remove("hidden");
  }


  openCustomRequestModal() {
    this.customRequestModalTarget.classList.remove("hidden");
  }

}